const FONTS = {
    PRIMARY_FONT: 'Telegraf',
    SECONDARY_FONT: 'Monument Extended',
    TERTIARY_FONT: 'Apotek Cond',
    QUATERNARY_FONT: 'Roboto'
};

export default FONTS;
